export enum Code {
  crushed = "Amassado",
  scratched = "Riscado",
  broken = "Quebrado"
}